// Helpers for the public fan orders page (/orders). Nothing about the fan is
// ever written to browser storage.

export const isOrdersPath = (pathname: string): boolean => {
    return /^\/orders(\/|$)/i.test(pathname);
};

export const ORDER_NUMBER_PATTERN = /^\d{4}-\d{6}-\d{4}$/;

export const isValidTokenShape = (t: string): boolean => {
    return /^[0-9a-f]{64}$/.test(t);
};

export const isSafeReceiptUrl = (url: string): boolean => {
    try {
        const parsed = new URL(url);
        if (parsed.protocol !== 'https:') {
            return false;
        }
        return parsed.hostname === 'stripe.com' || parsed.hostname.endsWith('.stripe.com');
    } catch (e) {
        return false;
    }
};
